export enum ROUTES {
  HOMEPAGE = "/",
  MY_COLLECTIONS = "/my-collections",
  COLLECTION = "/collections/:id",
  COLLECTIONS = "/collections",
  DATASETS = "/datasets",
  TOS = "/tos/",
  PRIVACY = "/privacy/",
  PREVIEW_POLICIES = "/previewpolicies/",
  WHERE_IS_MY_GENE = "/gene-expression",
  DOCS = "/docs",
  CELL_GUIDE = "/cellguide",
  CENSUS_MODELS = "/census-models",
  DE = "/differential-expression",
}
